import {
  jb_audio_player_css_default
} from "./chunk.ROUK46PH.js";
import {
  Spaceable,
  setLink
} from "./chunk.P6YYTXAQ.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ChangesBackgroundColor
} from "./chunk.DOB66LDT.js";
import {
  D,
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  e,
  n
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-audio-player/jb-audio-player.ts
var JbAudioPlayer = class extends ChangesBackgroundColor(Spaceable(r)) {
  constructor() {
    super(...arguments);
    this.headline = "";
    this.intersectionObserver = new IntersectionObserver((entries) => {
      if (entries[0].intersectionRatio <= 0) return;
      this.intersectionObserver.unobserve(this);
      this.dispatchEvent(
        new CustomEvent("jb-tracking", {
          detail: {
            event: "ce_audio",
            event_version: "v2",
            component_name: "audio-player",
            file_name: this.src.split("/").pop(),
            file_progress: "visible",
            file_type: this.src.split(".").pop()?.toLocaleLowerCase()
          },
          bubbles: true,
          composed: true
        })
      );
    });
    this.spriteSvgUrl = "";
    this._progress = 0;
  }
  update(changedProperties) {
    super.update(changedProperties);
    if (changedProperties.has("duration")) {
      this._updateRemainingTime();
    }
  }
  async firstUpdated() {
    document.addEventListener("keydown", (e2) => {
      if (e2.code === "KeyM") {
        this._audioElement.muted = !this._audioElement.muted;
      }
      if (e2.code === "ArrowUp") {
        this._audioElement.volume = Math.min(1, this._audioElement.volume + 0.1);
      }
      if (e2.code === "ArrowDown") {
        this._audioElement.volume = Math.max(0, this._audioElement.volume - 0.1);
      }
    });
    this._playPauseButton.setMediaElement(this._audioElement);
    this._boundDispatchStartEvent = this._dispatchStartEvent.bind(this);
    this._audioElement.addEventListener("play", this._boundDispatchStartEvent);
    this.intersectionObserver.observe(this);
  }
  _dispatchPercentageEvent() {
    this.dispatchEvent(
      new CustomEvent("jb-tracking", {
        detail: {
          event: "ce_audio",
          event_version: "v2",
          component_name: "audio-player",
          file_name: this.src.split("/").pop(),
          file_progress: this._progress + "%",
          file_type: this.src.split(".").pop()?.toLocaleLowerCase(),
          time_elapsed: Math.round(this.duration / 100 * this._progress)
        },
        bubbles: true,
        composed: true
      })
    );
  }
  _dispatchStartEvent() {
    this._audioElement.removeEventListener("play", this._boundDispatchStartEvent);
    this.dispatchEvent(
      new CustomEvent("jb-tracking", {
        detail: {
          event: "ce_audio",
          event_version: "v2",
          component_name: "audio-player",
          file_name: this.src.split("/").pop(),
          file_progress: "start",
          file_type: this.src.split(".").pop()?.toLocaleLowerCase()
        },
        bubbles: true,
        composed: true
      })
    );
  }
  _downloadClick(event) {
    event.stopPropagation();
    this.dispatchEvent(
      new CustomEvent("jb-tracking", {
        detail: {
          event: "ce_download",
          event_version: "v2",
          component_name: "listing",
          file_name: this.src.split("/").pop(),
          file_type: this.src.split(".").pop()?.toLowerCase()
        },
        bubbles: true,
        composed: true
      })
    );
  }
  _getContentSpacingProperties() {
    if (this.noVerticalSpace) {
      return { type: "no-vertical-space" };
    }
    return { type: "media" };
  }
  _handleSeekInput() {
    this._audioElement.currentTime = parseInt(this._seek.value, 10);
  }
  _initializeAudioMetaData() {
    this.duration = Math.round(this._audioElement.duration);
  }
  _setPodcastLink(link, icon, ariaLabel) {
    const anchor = document.createElement("a");
    setLink(anchor, link);
    anchor.innerHTML = icon;
    anchor.setAttribute("aria-label", ariaLabel);
    anchor.setAttribute("title", ariaLabel);
    return anchor;
  }
  _updateRemainingTime() {
    const currentTime = this._audioElement?.currentTime || 0;
    this._seek.value = Math.round(currentTime).toString();
    this._timer.seconds = -((this.duration || 0) - currentTime);
    const currentPercentagePlayed = this.duration > 0 ? Math.round(currentTime / this.duration * 10) * 10 : 0;
    if (currentPercentagePlayed > this._progress) {
      this._progress = currentPercentagePlayed;
      this._dispatchPercentageEvent();
    }
  }
  render() {
    return ke`
      <section>
        ${this.headline ? ke`<h4>${this.headline}</h4>` : D}
        <div class="description">
          ${this.description ? ke`<p>${this.description}</p>` : D}
          ${this.spotifyPodcastLink?.href || this.applePodcastLink?.href ? ke`
                <div class="links">
                  ${this.spotifyPodcastLink?.href ? this._setPodcastLink(
      this.spotifyPodcastLink,
      "<jb-spotify-icon>",
      this.ariaLabels?.spotifyPodcast
    ) : D}
                  ${this.applePodcastLink?.href ? this._setPodcastLink(
      this.applePodcastLink,
      "<jb-apple-podcast-icon>",
      this.ariaLabels?.applePodcast
    ) : D}
                </div>
              ` : D}
        </div>

        <div>
          <jb-play-pause-button
            .ariaLabelPause=${this.ariaLabels?.pause}
            .ariaLabelPlay=${this.ariaLabels?.play}
            .spriteSvgUrl=${this.spriteSvgUrl}
          ></jb-play-pause-button>
          <input
            aria-label="${this.ariaLabels?.seek ?? "Seek"}"
            @input=${this._handleSeekInput}
            type="range"
            min="0"
            value="0"
            max="${Math.round(this.duration)}"
          />
          <jb-timer
            .align=${"right"}
            .seconds=${this.duration}
          ></jb-timer>
        </div>
        <audio
          @timeupdate=${this._updateRemainingTime}
          @loadedmetadata=${this._initializeAudioMetaData}
          preload="metadata"
        >
          <source
            src="${this.src}"
            type="${this.mimeType}"
          />
        </audio>
        ${this.downloadText ? ke`
              <jb-listing-item
                .file=${{ size: this.fileSize || "", type: this.fileType || "" }}
                .link=${{
      href: this.src,
      data: { type: "download", downloadFileName: this.src.split("/").pop() || "" }
    }}
                .type=${"download"}
                .text=${this.downloadText}
                @jb-link:clicked=${this._downloadClick}
              ></jb-listing-item>
            ` : D}
      </section>
    `;
  }
};
JbAudioPlayer.styles = jb_audio_player_css_default;
__decorateClass([
  n({ type: Object })
], JbAudioPlayer.prototype, "applePodcastLink", 2);
__decorateClass([
  n({ type: Object })
], JbAudioPlayer.prototype, "ariaLabels", 2);
__decorateClass([
  n()
], JbAudioPlayer.prototype, "description", 2);
__decorateClass([
  n()
], JbAudioPlayer.prototype, "downloadText", 2);
__decorateClass([
  n({ type: Number })
], JbAudioPlayer.prototype, "duration", 2);
__decorateClass([
  n()
], JbAudioPlayer.prototype, "fileDate", 2);
__decorateClass([
  n()
], JbAudioPlayer.prototype, "fileId", 2);
__decorateClass([
  n()
], JbAudioPlayer.prototype, "fileSize", 2);
__decorateClass([
  n()
], JbAudioPlayer.prototype, "fileType", 2);
__decorateClass([
  n()
], JbAudioPlayer.prototype, "headline", 2);
__decorateClass([
  n()
], JbAudioPlayer.prototype, "mimeType", 2);
__decorateClass([
  n({ type: Boolean })
], JbAudioPlayer.prototype, "noVerticalSpace", 2);
__decorateClass([
  n({ type: Object })
], JbAudioPlayer.prototype, "spotifyPodcastLink", 2);
__decorateClass([
  n()
], JbAudioPlayer.prototype, "spriteSvgUrl", 2);
__decorateClass([
  n()
], JbAudioPlayer.prototype, "src", 2);
__decorateClass([
  e("audio")
], JbAudioPlayer.prototype, "_audioElement", 2);
__decorateClass([
  e("jb-play-pause-button")
], JbAudioPlayer.prototype, "_playPauseButton", 2);
__decorateClass([
  e("input")
], JbAudioPlayer.prototype, "_seek", 2);
__decorateClass([
  e("jb-timer")
], JbAudioPlayer.prototype, "_timer", 2);
JbAudioPlayer = __decorateClass([
  customElement("jb-audio-player")
], JbAudioPlayer);

export {
  JbAudioPlayer
};
